"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _input = _interopRequireDefault(require("antd/lib/input"));

var _link = require("@meepshop/link");

var _AdTrack = _interopRequireDefault(require("@meepshop/context/lib/AdTrack"));

var _locales = require("@meepshop/locales");

var _Icon = _interopRequireDefault(require("../menu/Icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/searchAction.less");

var styles = {
  "form": "meepshop-meep-ui__nav-searchAction__form",
  "input": "meepshop-meep-ui__nav-searchAction__input"
};

var SearchAction = function SearchAction(_ref) {
  var className = _ref.className,
      style = _ref.style;

  var _useTranslation = (0, _locales.useTranslation)('menu'),
      t = _useTranslation.t;

  var router = (0, _link.useRouter)();
  var adTrack = (0, _react.useContext)(_AdTrack["default"]);
  var prevValue = (0, _react.useRef)('');
  var currentValue = (0, _react.useRef)('');

  var _useState = (0, _react.useState)(router.query.search || ''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(!!router.query.search),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showSearchBar = _useState4[0],
      setShowSearchBar = _useState4[1];

  currentValue.current = value;

  var handleSearch = function handleSearch(newValue) {
    if (prevValue.current === newValue) return;
    router.push({
      pathname: '/products/',
      query: {
        search: newValue
      }
    });
    adTrack.search({
      searchString: newValue
    });
    prevValue.current = newValue;
  };

  (0, _react.useEffect)(function () {
    // 這不常見，但頁面可以多個選單，每個選單都可以開啟搜尋功能
    // 避免當搜尋功能開啟時，query 跟 value 不同步情況
    if (router.query.search && router.query.search !== currentValue.current) setValue(router.query.search);
  }, [router.query.search]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: style,
    onClick: function onClick() {
      setShowSearchBar(!showSearchBar);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    image: {
      __typename: 'DefaultIcon',
      icon: 'SEARCH'
    }
  }, showSearchBar ? /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.form
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    autoFocus: true,
    className: styles.input,
    type: "search",
    placeholder: t('search'),
    value: value,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    },
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onPressEnter: function onPressEnter(event) {
      return handleSearch(event.target.value);
    },
    enterkeyhint: "search"
  })) : null));
};

var _default = SearchAction;
exports["default"] = _default;